import {
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "react-bootstrap";
import styled from "styled-components";

interface TableFooterProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalItems: number;
  pageSize: number;
}

const PaginationBanner = styled.div`
  height: 50px;
`;

const PaginationButton = styled.button`
  height: 70%;
  border: none;
  background-color: inherit;
`;

const TableFooter = ({
  currentPage,
  setCurrentPage,
  totalItems,
  pageSize,
}: TableFooterProps) => {
  const getTotalPages = () => {
    const totalPages = Math.ceil(totalItems / pageSize);
    const r = totalPages > 0 ? totalPages : 1;
    return r;
  };

  return (
    <Row className="m-0 rounded">
      <PaginationBanner className="bg-light justify-content-center  d-flex">
        <div className="align-items-center d-flex justify-content-between">
          <PaginationButton
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}
          >
            <FontAwesomeIcon icon={faAnglesLeft}></FontAwesomeIcon>
          </PaginationButton>
          <PaginationButton
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            <FontAwesomeIcon icon={faAngleLeft}></FontAwesomeIcon>
          </PaginationButton>
          <div>
            Page {currentPage} of {getTotalPages()}
          </div>
          <PaginationButton
            disabled={currentPage === getTotalPages()}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            <FontAwesomeIcon icon={faAngleRight}></FontAwesomeIcon>
          </PaginationButton>
          <PaginationButton
            disabled={currentPage === getTotalPages()}
            onClick={() => setCurrentPage(Math.ceil(totalItems / pageSize))}
          >
            <FontAwesomeIcon icon={faAnglesRight}></FontAwesomeIcon>
          </PaginationButton>
        </div>
      </PaginationBanner>
    </Row>
  );
};

export default TableFooter;
